import { COLORS } from 'helpers/globals'

export default {
  '.rc-slider': {
    position: 'relative',
    height: 14,
    padding: '5px 0',
    width: '100%',
    borderRadius: 6,
    boxSizing: 'border-box',
    '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)'
  },
  '.rc-slider *': {
    boxSizing: 'border-box',
    '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)'
  },
  '.rc-slider-rail': {
    position: 'absolute',
    width: '100%',
    backgroundColor: '#e9e9e9',
    height: 4
  },
  '.rc-slider-track': {
    position: 'absolute',
    left: 0,
    height: 4,
    borderRadius: 6,
    'background-color': COLORS.primary
  },
  '.rc-slider-handle': {
    position: 'absolute',
    marginLeft: -7,
    marginTop: -5,
    width: 14,
    height: 14,
    cursor: 'pointer',
    borderRadius: '50%',
    border: `solid 2px ${COLORS.primary}`,
    backgroundColor: '#fff',
    '&:focus': {
      borderColor: COLORS.primary,
      boxShadow: `0 0 5px ${COLORS.primary}`,
      outline: 'none'
    }
  },
  '.rc-slider-handle:hover': {
    borderColor: COLORS.primary
  },
  '.rc-slider-handle-active:active': {
    borderColor: COLORS.primary,
    boxShadow: `0 0 5px ${COLORS.primary}`
  },
  '.rc-slider-mark': {
    position: 'absolute',
    top: 18,
    left: 0,
    width: '100%',
    fontSize: 12
  },
  '.rc-slider-mark-text': {
    position: 'absolute',
    display: 'inline-block',
    verticalAlign: 'middle',
    textAlign: 'center',
    cursor: 'pointer',
    color: '#999'
  },
  '.rc-slider-mark-text-active': {
    color: '#666'
  },
  '.rc-slider-step': {
    position: 'absolute',
    width: '100%',
    height: 4,
    background: 'transparent'
  },
  '.rc-slider-dot': {
    position: 'absolute',
    bottom: -2,
    marginLeft: -4,
    width: 8,
    height: 8,
    border: '2px solid #e9e9e9',
    backgroundColor: '#fff',
    cursor: 'pointer',
    borderRadius: '50%',
    verticalAlign: 'middle'
  },
  '.rc-slider-dot:first-child': {
    marginLeft: -4
  },
  '.rc-slider-dot:last-child': {
    marginLeft: -4
  },
  '.rc-slider-dot-active': {
    borderColor: COLORS.primary
  },
  '.rc-slider-disabled': {
    backgroundColor: '#e9e9e9'
  },
  '.rc-slider-disabled .rc-slider-track': {
    backgroundColor: '#ccc'
  },
  '.rc-slider-disabled .rc-slider-handle, .rc-slider-disabled .rc-slider-dot': {
    borderColor: '#ccc',
    backgroundColor: '#fff',
    cursor: 'not-allowed'
  },
  '.rc-slider-disabled .rc-slider-mark-text, .rc-slider-disabled .rc-slider-dot': {
    cursor: 'not-allowed !important'
  },
  '.rc-slider-vertical': {
    width: 14,
    height: '100%',
    padding: '0 5px'
  },
  '.rc-slider-vertical .rc-slider-rail': {
    height: '100%',
    width: 4
  },
  '.rc-slider-vertical .rc-slider-track': {
    left: 5,
    bottom: 0,
    width: 4
  },
  '.rc-slider-vertical .rc-slider-handle': {
    marginLeft: -5,
    marginBottom: -7
  },
  '.rc-slider-vertical .rc-slider-mark': {
    top: 0,
    left: 18,
    height: '100%'
  },
  '.rc-slider-vertical .rc-slider-step': {
    height: '100%',
    width: 4
  },
  '.rc-slider-vertical .rc-slider-dot': {
    left: 2,
    marginBottom: -4
  },
  '.rc-slider-vertical .rc-slider-dot:first-child': {
    marginBottom: -4
  },
  '.rc-slider-vertical .rc-slider-dot:last-child': {
    marginBottom: -4
  },
  '.rc-slider-tooltip-zoom-down-enter, .rc-slider-tooltip-zoom-down-appear, .rc-slider-tooltip-zoom-down-leave': {
    '-webkit-animation-duration': '.3s',
    'animation-duration': '.3s',
    '-webkit-animation-fill-mode': 'both',
    'animation-fill-mode': 'both',
    display: 'block !important',
    '-webkit-animation-play-state': 'paused',
    'animation-play-state': 'paused'
  },
  '.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active, .rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active': {
    '-webkit-animation-name': 'rcSliderTooltipZoomDownIn',
    'animation-name': 'rcSliderTooltipZoomDownIn',
    '-webkit-animation-play-state': 'running',
    'animation-play-state': 'running'
  },
  '.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active': {
    '-webkit-animation-name': 'rcSliderTooltipZoomDownOut',
    'animation-name': 'rcSliderTooltipZoomDownOut',
    '-webkit-animation-play-state': 'running',
    'animation-play-state': 'running'
  },
  '.rc-slider-tooltip-zoom-down-enter, .rc-slider-tooltip-zoom-down-appear': {
    '-webkit-transform': 'scale(0, 0)',
    'transform': 'scale(0, 0)',
    '-webkit-animation-timing-function': 'cubic-bezier(0.23, 1, 0.32, 1)',
    'animation-timing-function': 'cubic-bezier(0.23, 1, 0.32, 1)'
  },
  '.rc-slider-tooltip-zoom-down-leave': {
    '-webkit-animation-timing-function': 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
    'animation-timing-function': 'cubic-bezier(0.755, 0.05, 0.855, 0.06)'
  },
  '.rc-slider-tooltip': {
    position: 'absolute',
    left: -9999,
    top: -9999,
    visibility: 'visible',
    boxSizing: 'border-box',
    '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)'
  },
  '.rc-slider-tooltip *': {
    boxSizing: 'border-box',
    '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)'
  },
  '.rc-slider-tooltip-hidden': {
    display: 'none'
  },
  '.rc-slider-tooltip-placement-top': {
    padding: '4px 0 8px 0'
  },
  '.rc-slider-tooltip-inner': {
    padding: '6px 2px',
    minWidth: 24,
    height: 24,
    fontSize: 12,
    lineHeight: 1,
    color: '#fff',
    textAlign: 'center',
    textDecoration: 'none',
    backgroundColor: '#6c6c6c',
    borderRadius: 6,
    boxShadow: '0 0 4px #d9d9d9'
  },
  '.rc-slider-tooltip-arrow': {
    position: 'absolute',
    width: 0,
    height: 0,
    borderColor: 'transparent',
    borderStyle: 'solid'
  },
  '.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow': {
    bottom: 4,
    left: '50%',
    marginLeft: -4,
    borderWidth: '4px 4px 0',
    borderTopColor: '#6c6c6c'
  }
}

// @keyframes rcSliderTooltipZoomDownIn {
//   0% {
//     opacity: 0;
//     -webkit-transform-origin: 50% 100%;
//             transform-origin: 50% 100%;
//     -webkit-transform: scale(0, 0);
//             transform: scale(0, 0);
//   }
//   100% {
//     -webkit-transform-origin: 50% 100%;
//             transform-origin: 50% 100%;
//     -webkit-transform: scale(1, 1);
//             transform: scale(1, 1);
//   }
// }
// @-webkit-keyframes rcSliderTooltipZoomDownOut {
//   0% {
//     -webkit-transform-origin: 50% 100%;
//             transform-origin: 50% 100%;
//     -webkit-transform: scale(1, 1);
//             transform: scale(1, 1);
//   }
//   100% {
//     opacity: 0;
//     -webkit-transform-origin: 50% 100%;
//             transform-origin: 50% 100%;
//     -webkit-transform: scale(0, 0);
//             transform: scale(0, 0);
//   }
// }
// @keyframes rcSliderTooltipZoomDownOut {
//   0% {
//     -webkit-transform-origin: 50% 100%;
//             transform-origin: 50% 100%;
//     -webkit-transform: scale(1, 1);
//             transform: scale(1, 1);
//   }
//   100% {
//     opacity: 0;
//     -webkit-transform-origin: 50% 100%;
//             transform-origin: 50% 100%;
//     -webkit-transform: scale(0, 0);
//             transform: scale(0, 0);
//   }
// }



// WEBPACK FOOTER //
// ./src/assets/globalStyles/rcSlider.js